import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { getDistanceFromLatLon } from 'src/app/utils/utils.common';
import { PlannerHelpingService } from './planner-helping-service';
@Injectable({
  providedIn: 'root'
})
export class PlannerGroupService {

  user;
  preData;
  preFleet;
  selectedMapper;
  violation;
  timeCalibration;
  selectedDrivers;
  selectedMethod;
  preDrivers;
  shiftMapper;

  constructor(
    private assigTripsService: AssigTripsService,
    private plannerHelpingService: PlannerHelpingService
  ) { }

  async planTrips(user, preData, preFleet, violation, selectedMapper, selectedDrivers, selectedMethod, timeCalibration, manifestTrips, preDrivers, shiftMapper) {
    this.user = user;
    this.preData = preData;
    this.preFleet = preFleet;
    this.violation = violation;
    this.timeCalibration = timeCalibration;
    this.selectedMapper = selectedMapper;
    this.shiftMapper = shiftMapper;
    this.selectedDrivers = selectedDrivers;
    this.selectedMethod = selectedMethod;
    this.preDrivers = preDrivers

    let planedTrips = {
      trips: [],
      nonCompatible: [],
      compatible: {},
      tripLogs: {},
      driversDistance: {}
    };

    for (let trip of this.preData.trips) {
      if (this.preData.selectedTrips.includes(trip._id)) {
        planedTrips.trips.push(trip);
      }
    }

    //  if (this.timeCalibration && this.timeCalibration !== "none") {
    //     // set pickup and drop off time
    //     for (let trip of planedTrips.trips) {
    //       const distance = await this.calculateDistance(
    //         trip.jobOriginLatitude,
    //         trip.jobOriginLongitude,
    //         trip.jobDestinationLatitude,
    //         trip.jobDestinationLongitude
    //       );

    //          if (distance && distance.duration) {
    //                  if (timeCalibration === "pickup-wise") {
    //                    trip.scheduleTime = moment(trip.appointmentTime).tz(user.timeZone).subtract(distance.duration, 'minutes').toISOString();
    //                  } else {
    //                    trip.appointmentTime = moment(trip.scheduleTime).tz(user.timeZone).add(distance.duration, 'minutes').toISOString();
    //                  }
    //           }
    //     }
    //   }

    if (this.timeCalibration && this.timeCalibration !== "none") {
      if (this.timeCalibration === "pickup-wise") {
        await this.plannerHelpingService.applyPickupWiseCalibration(this.selectedMethod, planedTrips.trips, user);
      } else if (this.timeCalibration === "dropoff-wise") {
        await this.plannerHelpingService.applyDropoffWiseCalibration(this.selectedMethod, planedTrips.trips, user);
      } else {
        await this.plannerHelpingService.applyMemberWiseHybridCalibration(this.selectedMethod, planedTrips.trips, user);
      }
    }


    this.selectedDrivers.sort((a, b) =>
      a.displayName.localeCompare(
        b.displayName
      )
    );

    planedTrips.trips.sort((a, b) => {
      return moment(a.scheduleTime).tz(this.user.timeZone).diff(moment(b.scheduleTime).tz(this.user.timeZone));
    });


    if (manifestTrips && manifestTrips.length) {
      for (let item of manifestTrips) {
        if (await this.selectedDrivers.some(driver => driver._id === item.driver)) {
          if (item.driver) {
            if (!planedTrips.compatible[item.driver]) {
              planedTrips.compatible[item.driver] = {
                driver: preDrivers[item.driver],
                trips: []
              };
            }
            if (item) {
              item.preTrip = true;
              planedTrips.compatible[item.driver].trips.push(item);
            }
          }
        }
      }
    }

    await this.assignTripsToDrivers(planedTrips, selectedDrivers);
    await this.finalizeInterleavedSequences(planedTrips);

    // reset trips array after all planning
    planedTrips.trips = [];

    // Final Output Logs
    for (const driverId in planedTrips.compatible) {
      const data = planedTrips.compatible[driverId];
      if (data.driver) {
        console.log(`Driver: ${data.driver.displayName}`);
        console.log(`Trips IDs: ${data.trips.map(t => t.tripId).join(', ')}`);
        if (data.stops) {
          console.log(`Stops:`, data.stops.map(s => `${s.priority}. [${s.stopType}] Patient: ${s.personName || 'Unknown'} (${s.tripId})`));
        }
      }
    }
    return planedTrips;

  }

  async finalizeInterleavedSequences(planedTrips) {
    for (const driverId in planedTrips.compatible) {
      const driverData = planedTrips.compatible[driverId];
      if (driverData.executedStops) {
        driverData.stops = driverData.executedStops.map((stop, index) => {
          const stopObj = {
            ...stop,
            priority: index + 1,
            // UI expected properties:
            latitude: stop.lat,
            longitude: stop.lon,
            personName: stop.priorityClient ? stop.priorityClient.displayName : '',
            sortType: stop.type === 'P' ? 'pickup' : 'dropoff',
            stopType: stop.type === 'P' ? 'pickup' : 'dropoff',
            scheduledTime: stop.scheduleTime,
            appointmentTime: stop.appointmentTime,
            // estimatedArrivalTime is already set in checkStopBasedPossibility
          };
          return stopObj;
        });

        driverData.trips.forEach(trip => {
          const pickupStop = driverData.stops.find(stop => stop._id === trip._id && stop.stopType === 'pickup');
          const dropoffStop = driverData.stops.find(stop => stop._id === trip._id && stop.stopType === 'dropoff');
          trip.pickupOrder = pickupStop ? pickupStop.priority : null;
          trip.dropOffOrder = dropoffStop ? dropoffStop.priority : null;
        });
      }
    }
  }


  /**
 * Main method to assign trips to drivers.
 *
 * It iterates over trips (sorted by scheduleTime) and:
 * • Checks eligibility for each driver based on shift, fleet, funding, service area, and starting point.
 * • If a trip is from a client that already has an assigned driver (flag-based), it will only consider that driver.
 * • For each candidate driver, it ensures the trip fits into their current route.
 * • Finally, it chooses the best driver (minimizing added travel distance) and assigns the trip.
 *
 * @param {Array} trips - Array of trip objects.
 * @param {Array} drivers - Array of driver objects.
 * @returns {Object} A mapping from driver IDs to arrays of assigned trips.
 */
  async assignTripsToDrivers(planedTrips, drivers) {
    // Create a sorted copy of trips by scheduleTime (ascending).
    const clientDriverMap = {};  // { clientId: driverId } to enforce same-driver assignment for the same client

    for (let trip of planedTrips.trips) {
      // Use the priority client clientId if available; fallback to trip.client.
      const clientId = trip.priorityClient.displayName.toLowerCase();
      let candidateDrivers = [];
      let allDriversNearestTo = {};
      let isSameClient = false;

      if (this.violation && this.violation.prefferedToSameDriver && clientDriverMap[clientId]) {
        isSameClient = true;
        const driver = drivers.find((d) => d._id === clientDriverMap[clientId]);
        if (driver && this.isTripEligibleForDriver(planedTrips, trip, driver)) {
          candidateDrivers.push(driver);
        }
      } else {
        // Otherwise, consider all drivers who are eligible.
        candidateDrivers = drivers.filter((driver) => {
          const result = this.isTripEligibleForDriver(planedTrips, trip, driver);
          return result;
        }
        );
      }

      // Initialize results for this trip to avoid race conditions in parallel checks
      if (!allDriversNearestTo[trip._id]) { allDriversNearestTo[trip._id] = []; }

      // Filter candidate drivers further by checking if the trip can be fit into their route.
      let feasibleDrivers = await this.checkDriverRoutes(planedTrips, candidateDrivers, trip, allDriversNearestTo);

      if (feasibleDrivers.length === 0 && isSameClient) {
        console.warn(`Trip ${trip.tripId}. ${trip.priorityClient.displayName} could not be assigned based on current criteria. Rechecking with other drivers`);
        isSameClient = false;
        //consider all drivers who are eligible.
        candidateDrivers = drivers.filter((driver) => {
          const result = this.isTripEligibleForDriver(planedTrips, trip, driver);
          return result;
        });

        // Filter candidate drivers further by checking if the trip can be fit into their route.
        feasibleDrivers = await this.checkDriverRoutes(planedTrips, candidateDrivers, trip, allDriversNearestTo);
      }

      if (feasibleDrivers.length > 0) {
        // Choose the best driver (minimize extra travel distance).
        const chosenDriver = await this.chooseDriverForTrip(clientDriverMap[clientId], feasibleDrivers, allDriversNearestTo, trip, planedTrips.compatible);
        if (planedTrips.compatible[chosenDriver.driver._id]) {
          const selectedTripDistance = await this.calculateDistance(trip.jobOriginLatitude, trip.jobOriginLongitude, trip.jobDestinationLatitude, trip.jobDestinationLongitude);
          if (!planedTrips.driversDistance[chosenDriver.driver._id]) planedTrips.driversDistance[chosenDriver.driver._id] = 0;
          planedTrips.driversDistance[chosenDriver.driver._id] += selectedTripDistance.distance;

          planedTrips.compatible[chosenDriver.driver._id].trips.push(trip);
          planedTrips.compatible[chosenDriver.driver._id].executedStops = chosenDriver.stops;
        } else {
          planedTrips.compatible[chosenDriver.driver._id] = {
            driver: chosenDriver.driver,
            trips: [trip],
            executedStops: chosenDriver.stops
          }
        }

        // Ensure subsequent trips for the same client are assigned to this driver.
        clientDriverMap[clientId] = chosenDriver.driver._id;
      } else {
        planedTrips.nonCompatible.push(trip);
        console.warn(`Trip ${trip.tripId}. ${trip.priorityClient.displayName} could not be assigned based on current criteria.`);
      }
    };


    return planedTrips;
  }

  /**
   * Check if the driver meets fleet, funding, service area, and starting point requirements.
   *
   * @param {Object} trip - Trip object.
   * @param {Object} driver - Driver object.
   * @param {Number} startingPointThreshold - Maximum acceptable distance (in miles) from the driver's starting point to the trip’s pickup.
   */
  isTripEligibleForDriver(planedTrips, selectedTrip, driver, startingPointThreshold = 10) {

    let isCompatible = false;
    let logs = {};
    // debugger;
    const isFundingSourceWiseExist = this.fundingSourcesWiseTrip(selectedTrip, driver);
    logs = { ...logs, isFundingSourceWiseExist };
    if (isFundingSourceWiseExist) {
      const isDriverShiftWiseExist = this.checkDriverShift(selectedTrip, driver);
      logs = { ...logs, isDriverShiftWiseExist };
      if (isDriverShiftWiseExist) {
        const isServiceAreasWiseExist = this.serviceAreasWiseTrip(selectedTrip, driver);
        logs = { ...logs, isServiceAreasWiseExist };
        if (isServiceAreasWiseExist) {
          const isSpaceTypeWiseExist = this.spaceTypeWiseTrip(selectedTrip, driver);
          logs = { ...logs, isSpaceTypeWiseExist };
          if (isSpaceTypeWiseExist) {
            const isGenderWiseExist = this.genderWiseTrip(selectedTrip, driver);
            logs = { ...logs, isGenderWiseExist };
            if (isGenderWiseExist) {
              if (!planedTrips.driversDistance[driver._id]) planedTrips.driversDistance[driver._id] = 0;
              const isMaxFactor = this.checkTripMaxFactor(planedTrips, driver, planedTrips.driversDistance[driver._id]);
              logs = { ...logs, isMaxFactor };
              if (isMaxFactor) {
                isCompatible = true;
              }
            }
          }
        }
      }
    }
    // // 5. Ensure the driver's starting point is close enough to the trip's pickup location.
    // const { latitude: startLat, longitude: startLon } = driver.startingPointAddress;
    // const { jobOriginLatitude: tripPickupLat, jobOriginLongitude: tripPickupLon } = trip;
    // const distanceFromStart = this.haversineDistance(startLat, startLon, tripPickupLat, tripPickupLon);
    // if (distanceFromStart > startingPointThreshold) {
    //   return false;
    // }

    // create Trip logs
    if (!isCompatible) {
      if (planedTrips.tripLogs[driver._id]) {
        planedTrips.tripLogs[driver._id].reasons.push({
          trip: selectedTrip,
          logs
        });
      } else {
        planedTrips.tripLogs[driver._id] = {
          driver,
          reasons: [{
            trip: selectedTrip,
            logs
          }]
        }
      }
    }

    return isCompatible;
  }

  checkDriverShift(selectedTrip, driver) {
    let isExist = false;
    const start = moment(this.preData.date).tz(this.user.timeZone).startOf('day');
    const end = moment(this.preData.date).tz(this.user.timeZone).endOf('day');

    if (this.shiftMapper[driver._id] && this.shiftMapper[driver._id].shifts && this.shiftMapper[driver._id].shifts.length) {
      const checkTodayShift = this.shiftMapper[driver._id].shifts.find(item => item.day == start.day() && item.isEnabled);
      if (checkTodayShift && checkTodayShift.checkin && checkTodayShift.checkout) {
        start.set({ hour: Number(checkTodayShift.checkin.split(':')[0]), minute: Number(checkTodayShift.checkin.split(':')[1]) });
        end.set({ hour: Number(checkTodayShift.checkout.split(':')[0]), minute: Number(checkTodayShift.checkout.split(':')[1]) });

        if (moment(selectedTrip.scheduleTime).tz(this.user.timeZone).isBetween(start, end, null, '[]') &&
          moment(selectedTrip.appointmentTime).tz(this.user.timeZone).isBetween(start, end, null, '[]')) {
          isExist = true;
        }
      }
    }
    return isExist;
  }

  checkTripMaxFactor(planedTrips, driver, totalDistance) {
    let isExecute = true;
    // total trips check
    if (this.violation) {
      let numberOfTrips = true;
      if (this.violation && this.violation.maxPerRun) {
        if (planedTrips.compatible[driver._id] && planedTrips.compatible[driver._id].trips) {
          if (planedTrips.compatible[driver._id].trips.length >= this.violation.maxPerRun) {
            numberOfTrips = false
          }
        }

      }

      let numberOfTripsMiles = true;
      if (this.violation && this.violation.maxDistancePerRun) {
        if (totalDistance >= this.violation.maxDistancePerRun) {
          numberOfTripsMiles = false
        }
      }

      isExecute = (numberOfTrips && numberOfTripsMiles);
    }

    return isExecute;
  }

  fundingSourcesWiseTrip(selectedTrip, driver) {
    let isExist = false;

    const isfundingSource = driver.fundingSources.some(d => d.name === selectedTrip.cooperate && moment(this.preData.date).isBetween(moment(d.validityRange[0]).tz(this.user.timeZone).subtract(1, 'day'), moment(d.validityRange[1]).tz(this.user.timeZone).add(1, 'day')));
    if (selectedTrip.cooperate && isfundingSource) {
      const driverFleetId = this.selectedMapper.mappers[driver._id];
      if (driverFleetId) {
        if (this.preFleet[driverFleetId] && this.preFleet[driverFleetId].fundingSources && this.preFleet[driverFleetId].fundingSources.includes(selectedTrip.cooperate)) {
          isExist = true;
        }
      }
    }
    return isExist;
  }

  serviceAreasWiseTrip(selectedTrip, driver) {
    let isExist = false;
    if (selectedTrip.serviceArea && this.shiftMapper[driver._id] && this.shiftMapper[driver._id].serviceAreas.includes(selectedTrip.serviceArea)) {
      isExist = true;
    }
    return isExist;
  }

  spaceTypeWiseTrip(selectedTrip, driver) {
    let isExist = false;

    if (this.violation && !this.violation.isCapacityViolation) {
      const driverFleetId = this.selectedMapper.mappers[driver._id];
      if (driverFleetId) {
        if (selectedTrip.spaceType && driverFleetId && this.preFleet[driverFleetId]) {
          isExist = this.preFleet[driverFleetId].capacities.some(capacity => capacity.spaceType === selectedTrip.spaceType);
        }
      }
    } else {
      isExist = true;
    }
    return isExist;
  }

  genderWiseTrip(selectedTrip, driver) {
    let isExist = true;

    if (selectedTrip.priorityClient.isPrefferedFemale) {
      isExist = driver.gender.toLowerCase() === 'female'
    }

    if (selectedTrip.preferredDriver) {
      isExist = driver._id === selectedTrip.priorityClient.preferredDriver;
    }
    return isExist;

  }

  async canFitTripInDriverRoute(planedTrips, driver, trip, allDriversNearestTo) {
    let result = await this.checkStopBasedPossibility(planedTrips, driver, trip);

    if (result.isAllow) {
      allDriversNearestTo[trip._id].push({
        driverId: driver._id,
        position: result.position,
        index: result.index,
        stops: result.stops
      });
    } else {
      let logs = {
        isFundingSourceWiseExist: true,
        isDriverShiftWiseExist: true,
        isServiceAreasWiseExist: true,
        isSpaceTypeWiseExist: true,
        istimeWiseTripExist: result.isNearbyViolation ? false : false,
      };

      if (planedTrips.tripLogs[driver._id]) {
        planedTrips.tripLogs[driver._id].reasons.push({ trip: trip, logs });
      } else {
        planedTrips.tripLogs[driver._id] = { driver, reasons: [{ trip: trip, logs }] };
      }
    }

    return result.isAllow;
  }

  async checkStopBasedPossibility(planedTrips, driver, trip) {
    let result: any = { isAllow: false, position: null, index: null, stops: null };
    const assignedTrips = (planedTrips.compatible[driver._id] && planedTrips.compatible[driver._id].trips) ? planedTrips.compatible[driver._id].trips : [];

    const candidateTrips = [...assignedTrips, trip];
    const stops = [];
    candidateTrips.forEach(t => {
      stops.push({
        _id: t._id,
        tripId: t.tripId,
        type: 'P',
        time: moment(t.scheduleTime).tz(this.user.timeZone).valueOf(),
        lat: t.jobOriginLatitude,
        lon: t.jobOriginLongitude,
        spaceType: t.spaceType,
        priorityClient: t.priorityClient,
        scheduleTime: t.scheduleTime,
        appointmentTime: t.appointmentTime
      });
      stops.push({
        _id: t._id,
        tripId: t.tripId,
        type: 'D',
        time: moment(t.appointmentTime).tz(this.user.timeZone).valueOf(),
        lat: t.jobDestinationLatitude,
        lon: t.jobDestinationLongitude,
        spaceType: t.spaceType,
        priorityClient: t.priorityClient,
        scheduleTime: t.scheduleTime,
        appointmentTime: t.appointmentTime
      });
    });

    stops.sort((a, b) => {
      // 1. Sort by time ascending
      if (a.time !== b.time) return a.time - b.time;

      // 2. Pickup always before Dropoff (requested by user)
      if (a.type !== b.type) return a.type === 'P' ? -1 : 1;

      // 3. Default stable sort
      return (a.tripId || '').localeCompare(b.tripId || '');
    });

    const driverFleetId = this.selectedMapper ? this.selectedMapper.mappers[driver._id] : null;
    const vehicleCapacities = (driverFleetId && this.preFleet[driverFleetId]) ? (this.preFleet[driverFleetId].capacities || []) : [];

    const currentLoad = {};
    for (const stop of stops) {
      if (stop.type === 'P') {
        currentLoad[stop.spaceType] = (currentLoad[stop.spaceType] || 0) + 1;
        if (this.violation && !this.violation.isCapacityViolation) {
          const vCap = vehicleCapacities.find(c => c.spaceType === stop.spaceType);
          if (!vCap || currentLoad[stop.spaceType] > vCap.capacity) return result;
        }
      } else {
        currentLoad[stop.spaceType] = (currentLoad[stop.spaceType] || 0) - 1;
        if (currentLoad[stop.spaceType] < 0) currentLoad[stop.spaceType] = 0;
      }
    }

    const startOfDay = moment(this.preData.date).tz(this.user.timeZone).startOf('day');
    const todayShift = this.shiftMapper[driver._id] ? this.shiftMapper[driver._id].shifts.find(s => s.day === startOfDay.day() && s.isEnabled) : null;

    if (!todayShift || !todayShift.checkin || !todayShift.checkout) {
      return result;
    }

    let currentTime = moment(startOfDay).set({ hour: Number(todayShift.checkin.split(':')[0]), minute: Number(todayShift.checkin.split(':')[1]) });
    let checkoutTime = moment(startOfDay).set({ hour: Number(todayShift.checkout.split(':')[0]), minute: Number(todayShift.checkout.split(':')[1]) });

    let currentLat = driver.startingPointAddress ? driver.startingPointAddress.latitude : null;
    let currentLon = driver.startingPointAddress ? driver.startingPointAddress.longitude : null;

    if (currentLat === null || currentLon === null) return result;

    const relaxationMargin = this.violation ? this.violation.groupCushion : 15;
    let passengersOnBoard = 0;

    for (const stop of stops) {
      const travel = await this.calculateDistance(currentLat, currentLon, stop.lat, stop.lon);
      currentTime.add(travel.duration, 'minutes');

      // Targeted 5-mile radius check for grouping (Pickup stops)
      // Only enforce for the NEW trip being added AND only if vehicle is NOT empty
      if (stop.type === 'P' && stop._id === trip._id && passengersOnBoard > 0 && travel.distance > (this.violation ? this.violation.groupRadius : 5)) {
        if (this.violation && !this.violation.isNearbyViolation) {
          result.isNearbyViolation = true;
          return result;
        }
      }

      const stopTargetTime = moment(stop.time).tz(this.user.timeZone);
      const earliestWindow = stopTargetTime.clone().subtract(10, 'minutes');
      if (currentTime.isBefore(earliestWindow)) {
        currentTime = earliestWindow.clone();
      }

      // Capture Arrival Time (Reflects the 10-min snap if early)
      stop.estimatedArrivalTime = currentTime.toISOString();

      if (this.violation && !this.violation.isTimeViolation) {
        if (currentTime.isAfter(stopTargetTime.clone().add(relaxationMargin, 'minutes'))) return result;
      }

      // Shared Stop Optimization
      let serviceTimeMinutes = 0;
      if (currentLat === stop.lat && currentLon === stop.lon) {
        serviceTimeMinutes = 2; // Co-passenger shared stop
      } else {
        const stData = this.preData.spaceTypes ? this.preData.spaceTypes[stop.spaceType] : null;
        if (stData) {
          const stValue = stData[stop.type === 'P' ? 'loadTime' : 'unloadTime'];
          const [h, m] = stValue.split(':').map(Number);
          serviceTimeMinutes = (h * 60) + m;
        }
      }
      currentTime.add(serviceTimeMinutes, 'minutes');

      // Departure check: cannot leave before stop time
      if (currentTime.isBefore(stopTargetTime)) {
        currentTime = stopTargetTime.clone();
      }

      // Update passenger count for the next segment
      if (stop.type === 'P') {
        passengersOnBoard++;
      } else {
        passengersOnBoard--;
        if (passengersOnBoard < 0) passengersOnBoard = 0;
      }

      currentLat = stop.lat;
      currentLon = stop.lon;
    }

    if (currentTime.isAfter(checkoutTime.add(relaxationMargin, 'minutes'))) return result;

    const newStart = moment(trip.scheduleTime).tz(this.user.timeZone);
    let insertIndex = assignedTrips.length;
    for (let i = 0; i < assignedTrips.length; i++) {
      if (newStart.isBefore(moment(assignedTrips[i].scheduleTime).tz(this.user.timeZone))) {
        insertIndex = i;
        break;
      }
    }

    result.isAllow = true;
    result.index = insertIndex;
    result.position = (insertIndex > 0 && assignedTrips[insertIndex - 1]) ? assignedTrips[insertIndex - 1]._id : null;
    result.stops = stops.map((s, idx) => ({ ...s, stopType: s.type === 'P' ? 'pickup' : 'dropoff', priority: idx + 1 }));
    return result;
  }


  /**
   * From a list of feasible drivers, choose the best one based on the minimal extra travel distance.
   *
   * The extra distance is measured from either the driver's starting point (if no trips are yet assigned)
   * or the last trip’s dropoff location.
   *
   * @param {Array} feasibleDrivers - Array of driver objects that passed eligibility and feasibility checks.
   * @param {Object} trip - The trip to assign.
   * @param {Object} assignments - Mapping from driver._id to an array of assigned trips.
   */
  async chooseDriverForTrip(clientDriverId, feasibleDrivers, allDriversNearestTo, selectedTrip, compatible) {
    let bestDriver = null;
    let minExtraDistance = Infinity;

    for (let driver of feasibleDrivers) {
      let referencePoint = null;
      const nearestToTripDetails = (allDriversNearestTo[selectedTrip._id] && allDriversNearestTo[selectedTrip._id].find(item => item.driverId === driver._id)) ? allDriversNearestTo[selectedTrip._id].find(item => item.driverId === driver._id) : null;
      let index = nearestToTripDetails ? nearestToTripDetails.index : null;
      let stops = nearestToTripDetails ? nearestToTripDetails.stops : null;

      //  assing A and B to same driver
      if (this.violation && this.violation.prefferedToSameDriver) {
        if (clientDriverId === driver._id) {
          bestDriver = { driver, index, stops };
          break;
        }
      }

      // If we have validated stops, use the one immediately before our pickup as the reference
      if (stops && stops.length > 0) {
        const myPickupStop = stops.find(s => s._id === selectedTrip._id && s.stopType === 'pickup');
        if (myPickupStop && myPickupStop.priority > 1) {
          const prevStop = stops.find(s => s.priority === myPickupStop.priority - 1);
          referencePoint = {
            lat: prevStop.lat,
            lon: prevStop.lon
          };
        } else {
          referencePoint = {
            lat: driver.startingPointAddress ? driver.startingPointAddress.latitude : null,
            lon: driver.startingPointAddress ? driver.startingPointAddress.longitude : null,
          };
        }
      } else {
        referencePoint = {
          lat: driver.startingPointAddress.latitude,
          lon: driver.startingPointAddress.longitude,
        };
      }

      const checkpossibleDistance = await this.calculateDistance(referencePoint.lat, referencePoint.lon, selectedTrip.jobOriginLatitude, selectedTrip.jobOriginLongitude);
      if (checkpossibleDistance.distance < minExtraDistance) {
        minExtraDistance = checkpossibleDistance.distance;
        bestDriver = { driver, index, stops };
      }
    }

    return bestDriver;
  }

  //  checkDriverRoutes(planedTrips, candidateDrivers, trip, allDriversNearestTo) {
  //   const feasibleDrivers = candidateDrivers.filter(async (driver) => {
  //     const result = await this.canFitTripInDriverRoute(planedTrips, driver, trip, allDriversNearestTo);
  //     return result;
  //   });

  //   return feasibleDrivers;
  // }

  async checkDriverRoutes(planedTrips, candidateDrivers, trip, allDriversNearestTo) {
    const feasibleDrivers = await Promise.all(
      candidateDrivers.map(async (driver) => {
        const result = await this.canFitTripInDriverRoute(planedTrips, driver, trip, allDriversNearestTo);
        return result ? driver : null;
      })
    );
    return feasibleDrivers.filter(driver => driver !== null);
  }



  async calculateDistance(lat1, lon1, lat2, lon2) {
    let resutl;
    if (this.selectedMethod && this.selectedMethod === true) {
      resutl = await this.calculateDistanceWithGIS(lat1, lon1, lat2, lon2);
    } else {
      resutl = await new Promise((resolve) => { resolve(getDistanceFromLatLon(lat1, lon1, lat2, lon2)) });
    }
    return resutl;
  }


  async calculateDistanceWithGIS(lat1, lon1, lat2, lon2) {
    const res: any = await this.assigTripsService.getRoutingDistance(lat1, lon1, lat2, lon2).toPromise();
    const segments: any = res.features[0].properties.segments;
    return {
      distance: (segments[0].distance / 1609),
      duration: (segments[0].duration / 60)
    };
  }
}


